import DateCell from '../../../elements/Table/Cells/DateCell'
import React from 'react'
import CustomTable from '../../../elements/Table/CustomTable'
import { Button, Tag } from 'antd'
import StatusCell from '../../../elements/Table/Cells/StatusCell'
import OrganisationsSelect from '../../../elements/Select/Organistaions'
import { Link, withRouter } from 'react-router-dom'

function NewsletterList(props) {
  const { list, fetch, fetching, onShow, company, onChangeCompany } = props
  const columns = [
    {
      Header: 'Code',
      accessor: 'code',
      Cell: ({ value, original }) => (
        <Link
          to={{
            pathname: `/newsletter/${original._key}/update`,
          }}>
          {value}
        </Link>
      ),
    },
    { Header: 'Subject', accessor: 'subject' },
    { Header: 'From', accessor: 'from' },
    { Header: 'Company', accessor: 'company.fn' },
    {
      Header: 'Tags',
      accessor: 'tags',
      width: 150,
      Cell: ({ value }) => {
        return value ? value.map((t) => <Tag color={'#108ee9'}>{t}</Tag>) : value
      },
    },
    { Header: 'Send Date', accessor: 'sendDate', Cell: DateCell },
    { Header: 'Status', accessor: 'status', Cell: StatusCell, width: 100 },
  ]

  return (
    <CustomTable
      data={list}
      defaultPageSize={20}
      isFilterable={true}
      fetching={fetching}
      fetch={fetch}
      CreateButton={() => (
        <Button
          onClick={() => {
            props.history.push({
              pathname: `/newsletter/new`,
            })
          }}
          type={'primary'}
          size="small"
          icon={'plus'}>
          New
        </Button>
      )}
      columns={columns}
      ExtraOptionsButtons={() => (
        <OrganisationsSelect
          value={company}
          onChange={onChangeCompany}
          placeholder={'Filter by a company'}
          size={'small'}
          style={{ width: '450px', paddingRight: 20, float: 'right' }}
        />
      )}
      defaultSorted={[
        {
          id: '_key',
          desc: false,
        },
      ]}
    />
  )
}

export default withRouter(NewsletterList)
